export const UPDATE_REQUEST_ID = 'UPDATE_REQUEST_ID';

export const updateRequestId = (payload: string) => ({
    type: UPDATE_REQUEST_ID,
    payload,
});

export default (state = '' as string, action: ReturnType<typeof updateRequestId>) =>
    action.type === UPDATE_REQUEST_ID ? action.payload : state;
